import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AllEmployees from "./all";
import ApprovedEmployees from "./approved";
import UnApprovedEmployees from "./unApproved";
import { getOutletFromCookies } from "../../../utils/Auth";

const tops = [
  { name: "All", href: "all" },
  { name: "Approved", href: "approved" },
  { name: "Unapproved", href: "unapproved" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Employees() {
  const outlet = getOutletFromCookies();
  const navigate = useNavigate();
  const DEFAULT_ACTIVE_TAB = "all";
  const { active_tab } = useParams();
  useEffect(() => {
    if (!active_tab) {
      navigate(
        `/admin/${
          outlet?.store_name || outlet?.restaurant_name
        }/employees/${DEFAULT_ACTIVE_TAB}/1`
      );
    }
  });

  const toggle = (tab) => {
    if (active_tab !== tab) {
      navigate(
        `/admin/${outlet?.store_name || outlet?.restaurant_name}/employees/${
          tab.href
        }/1`
      );
    }
  };

  return (
    <div className="employees-page">
      {/* <div className="mb-10">
        <h1 className="text-3xl font-semibold text-gray-900">
          {active_tab === "all"
            ? "All Employees"
            : active_tab === "approved"
            ? "Approved Employees"
            : active_tab === "unapproved"
            ? "Unapproved Employees"
            : ""}
        </h1>
      </div> */}
      <div className="sm:block">
        <div className="border-b border-gray-200">
          <nav
            className="-mb-px flex space-x-8 overflow-x-scroll sm:overflow-hidden"
            aria-label="Tabs"
          >
            {tops.map((tab) => (
              <button
                key={tab.name}
                onClick={() => {
                  toggle(tab);
                }}
                className={classNames(
                  tab.href === active_tab
                    ? "border-primary text-primary font-bold"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                )}
                aria-current={tab.href === active_tab ? "page" : undefined}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div>
        {active_tab === "all" && <AllEmployees />}
        {active_tab === "approved" && <ApprovedEmployees />}
        {active_tab === "unapproved" && <UnApprovedEmployees />}
      </div>
    </div>
  );
}
